<template>
  <div :id='randomId'>
    <ejs-listview id='flat-list' ref="listNe" :dataSource='data'></ejs-listview>
  </div>
</template>

<script>
  import { EventBus } from '../../../../plugins/eventBus';
  export default {
    name: 'NeList',
    props: [
      'neArr',
      'select',
      'keywords'
    ],
    data() {
      return {
        data: [],
        primaryDatas: [],
        $formId: ''
      };
    },
    computed: {
      randomId() {
        const _temp = 'abcdefghijklmnopqrstuvwxyz';
        this.$formId = '';
        for (let i = 0; i < 5; i++) {
          this.$formId += _temp[Math.round(Math.random(1) * 26)];
        };
        return this.$formId;
      }
    },
    methods: {
      _getNeTreeData() {
        const $this = this;
        $this.data = [];
        this.$axios.post('/lte/ems/auth/findElementListByAuth', this.neArr).then((response) => {
          const _nodeArray = response.data;
          this.$axios.get('/lte/ems/topo/device/devPage?pageNo=1&pageSize=2000').then((response) => {
            const { result } = response.data.resultVal;
            const showData = [];
            const showPrimaryDatas = [];
            _nodeArray.forEach((item) => {
              result.forEach((value) => {
                value.equipmentIPList.forEach((eitem) => {
                  if (eitem.id === item.equipmentIPId) {
                    if(value.typeCode === 10002) {
                      const { id, name, equipmentIP, equipmentIPId, typeCode, softwareVersion } = item;
                      const _dataItem = {
                        text: `${id}-${name}`,
                        id: id,
                        neType: typeCode,
                        tooltip: equipmentIP,
                        equipmentIPId: equipmentIPId,
                        neversion: softwareVersion,
                      };
                      showData.push(_dataItem);
                      showPrimaryDatas.push(_dataItem);
                    }
                  }
                });
              });
            });
            $this.data = showData;
            $this.primaryDatas = showPrimaryDatas;
          });
        });
      },
      doSearch() {
        if (this.keywords === '') {
          this.data = this.primaryDatas;
          return;
        }
        const leftNeDatas = this.primaryDatas.filter(neData => (neData.text.includes(this.keywords)));
        this.data = leftNeDatas;
      },
      getNe() {
        return this.$refs.listNe.getSelectedItems();
      },
      getOnlineNe() {
        const $this = this;
        const node = $this.$refs.listNe.getSelectedItems();
        $this.axios.get(`/lte/ems/config/mml/queryNodeLinkStatus/${node.data.id}`).then(res => {
          const nodeStatus = res.data ? res.data.resultVal : 0;
          if (nodeStatus === 0) {
            EventBus.$emit('toast', { type: 'warning', content: $this.$t('Common.neOffLine', [node.data.text]) });
          }
        });
        return node;
      }
    },
    beforeMount() {
      this._getNeTreeData();
    },
    updated() {
      const $this = this;
      document.getElementById(this.$formId).onclick = function () {
        $this.select();
      };
    }
  };

</script>

<style scoped>

</style>
